// src/pages/RegistroPublico.jsx
import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

export default function RegistroPublico() {
  const { token } = useParams(); // Asume que tu ruta es /registro-publico/ref=:token
  const navigate = useNavigate();
  
  const [valido, setValido] = useState(null);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nombres: '',
    apellidos: '',
    email: '',
    telefono: '',
    grado: 'APRENDIZ',
    password: ''
  });

  // Validar el token al montar el componente
  useEffect(() => {
    const validarEnlace = async () => {
      try {
        const res = await fetch(`https://logia-production-725b.up.railway.app/api/invitaciones/validar/${token}`);
        const data = await res.json();
        setValido(data.success);
      } catch (error) {
        setValido(false);
      }
    };
    validarEnlace();
  }, [token]);

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await fetch('https://logia-production-725b.up.railway.app/api/registro-publico', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ ...formData, token })
      });

      const data = await response.json();

      if (data.success) {
        alert('Registro exitoso. Tu cuenta está pendiente de aprobación por la Secretaría.');
        navigate('/login');
      } else {
        alert(data.error || 'Error al registrarse');
      }
    } catch (error) {
      alert('Error de conexión con el servidor.');
    } finally {
      setLoading(false);
    }
  };

  if (valido === null) {
    return <div className="min-h-screen bg-[#050505] flex justify-center items-center text-[#C5A059] tracking-widest text-xs uppercase animate-pulse">Validando enlace...</div>;
  }

  if (valido === false) {
    return (
      <div className="min-h-screen bg-[#050505] flex flex-col justify-center items-center text-center px-6">
        <h1 className="font-serif text-3xl text-red-500 mb-4">Enlace Inválido o Caducado</h1>
        <p className="text-gray-400 font-light text-sm max-w-md leading-relaxed">
          Este enlace de invitación ya no es válido. Por favor, solicita un nuevo enlace a la Secretaría de la Logia.
        </p>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-[#050505] flex flex-col justify-center items-center relative overflow-hidden font-sans">
      <div className="absolute inset-0 bg-[url('https://www.transparenttextures.com/patterns/stardust.png')] opacity-20 mix-blend-overlay pointer-events-none"></div>
      <div className="absolute inset-0 bg-gradient-to-br from-[#050505] via-[#050505]/95 to-[#111111] z-0 pointer-events-none"></div>

      <div className="relative z-10 w-full max-w-lg px-6 py-12 animate-fade-in">
        <div className="text-center mb-10">
          <span className="text-[#C5A059] text-[10px] tracking-[0.4em] uppercase block mb-4 font-semibold">Gran Logia del Perú</span>
          <h1 className="font-serif text-4xl text-white font-normal tracking-tight mb-2">Registro de HH:.</h1>
          <div className="w-12 h-[1px] bg-[#C5A059] mx-auto mt-6 mb-4"></div>
        </div>

        <div className="bg-[#0a0a0a] border border-white/10 p-8 shadow-2xl relative">
          <div className="absolute top-0 left-0 w-full h-[2px] bg-gradient-to-r from-transparent via-[#C5A059] to-transparent opacity-50"></div>

          <form onSubmit={handleSubmit} className="flex flex-col gap-5">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-2 font-semibold">Nombres</label>
                <input type="text" name="nombres" required onChange={handleChange} className="w-full bg-[#050505] border border-white/10 text-white px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors text-sm" />
              </div>
              <div>
                <label className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-2 font-semibold">Apellidos</label>
                <input type="text" name="apellidos" required onChange={handleChange} className="w-full bg-[#050505] border border-white/10 text-white px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors text-sm" />
              </div>
            </div>

            <div>
              <label className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-2 font-semibold">Correo Electrónico</label>
              <input type="email" name="email" required onChange={handleChange} className="w-full bg-[#050505] border border-white/10 text-white px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors text-sm" />
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <label className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-2 font-semibold">Teléfono</label>
                <input type="tel" name="telefono" required onChange={handleChange} className="w-full bg-[#050505] border border-white/10 text-white px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors text-sm" />
              </div>
              <div>
                <label className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-2 font-semibold">Grado Actual</label>
                <select name="grado" onChange={handleChange} className="w-full bg-[#050505] border border-white/10 text-gray-300 px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors text-sm appearance-none">
                  <option value="APRENDIZ">Aprendiz</option>
                  <option value="COMPAÑERO">Compañero</option>
                  <option value="MAESTRO">Maestro</option>
                </select>
              </div>
            </div>

            <div>
              <label className="text-[#C5A059] text-[10px] tracking-[0.2em] uppercase block mb-2 font-semibold">Contraseña de Acceso</label>
              <input type="password" name="password" required onChange={handleChange} className="w-full bg-[#050505] border border-white/10 text-white px-4 py-3 focus:outline-none focus:border-[#C5A059] transition-colors text-sm" />
            </div>

            <button type="submit" disabled={loading} className="w-full mt-4 bg-[#C5A059] hover:bg-white text-[#050505] font-semibold text-xs tracking-[0.2em] uppercase py-4 transition-colors duration-300 disabled:opacity-50">
              {loading ? 'Procesando...' : 'Enviar Solicitud'}
            </button>
          </form>
        </div>
      </div>
    </div>
  );
}